.animation-container {
    width: 427px;
    height: 320px;
    border-radius: 16px;
    overflow: hidden;
}

.text-field-container {
    width: 400px;
}
